module.exports = __webpack_public_path__ + "static/media/key-left.2601d4bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/key-left.svg
// module id = 3080
// module chunks = 7